// This link implments a similar set of logic to the crex client.
// If you update any cookie logic here you should make sure that it
// is compatible with this code:
// https://github.com/stitchfix/crex_client/blob/master/lib/stitch_fix/crex_client/controller_helpers/algo_tracking.rb

import Cookies from 'js-cookie';
import { ApolloLink } from '@apollo/client';

const MAX_ALGO_COOKIES = 5;

const algoRequestCookieKeys = (): string[] => {
  return Object.keys(Cookies.get()).filter(cookieName => {
    return cookieName.startsWith('algo-tracking-id');
  });
};

const cleanupCookies = (names: string[]) => {
  for (const name of names) {
    // Only delete cookies where value is not the current path
    // paths may be url encoded (eg. if generated from rails)
    const cookieVal = Cookies.get(name) ?? '';
    if (decodeURIComponent(cookieVal) !== window.location.pathname) {
      Cookies.remove(name);
    }
  }
};

const algoRequestIdTracker = new ApolloLink((operation, forward) => {
  return forward(operation).map(data => {
    const response = operation.getContext().response;
    const algoRequestIdHeader =
      response.headers.get('X-Algo-Request-Ids') || '';

    const algoCookies = algoRequestCookieKeys();

    if (algoCookies.length > MAX_ALGO_COOKIES) {
      cleanupCookies(algoCookies);
    }

    for (const requestId of algoRequestIdHeader.split(',')) {
      if (requestId) {
        Cookies.set(requestId, window.location.pathname);
      }
    }

    return data;
  });
});

export default algoRequestIdTracker;
